
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PatentDbApi } from '@telecom/shared/infrastructure/api-functions/patent-db-api';
import type { IResponseDbConfigData, PatentDbService } from '../patent-db-service';

@injectable()
export class PatentDbServiceImpl implements PatentDbService {
    constructor(
        @inject(PatentDbApi)
        private readonly _patentDbApi: PatentDbApi,
    ) {}
    getDbConfig(): Promise<IResponseDbConfigData> {
        return this._patentDbApi.getDbConfig();
    }
}
